module.exports = __webpack_public_path__ + "img/Group 126@2x.655a69c2.png";